export default function HeroVideo() {
  const videoId = 'fLiJwl54zok';
  const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1`;

  return (
    <div className="relative w-full h-full flex items-center justify-center bg-black overflow-hidden">
      {/* Scale up iframe so YouTube letterboxing is cropped out */}
      <div className="absolute inset-0 scale-[1.5] pointer-events-none">
        <iframe
          src={src}
          title="Blackmagic Films showreel"
          className="w-full h-full"
          allow="autoplay; encrypted-media"
          allowFullScreen={false}
          frameBorder="0"
        />
      </div>

      {/* top/bottom legibility gradient */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />

      {/* Skip to content */}
      <div className="absolute bottom-4 right-4">
        <a
          href="#reel"
          className="rounded-full bg-white text-black px-4 py-2 text-sm font-semibold hover:opacity-90 transition"
        >
          Skip
        </a>
      </div>
    </div>
  );
}
